export default class FormRuleManager {
    constructor(handler, rules = [], translations = {}) {
        this.handler = handler;
        this.rules = {};
        this.translations = translations;

        this.loadRules(rules);
    }


    getBody() {
        return this.handler.getBody();
    }

    loadRules(rules = []) {
        const handlers = this.getRulesHandler();


        if (rules.length === 0) {
            console.log('Warning: no rules set');
        }

        rules.forEach(rule => {
            if (typeof rule === 'function') {
                this.rules[Date.now()] = rule(this);
            }

            else {
                let ruleName = '';
                let settings = {};

                if (typeof  rule === 'string') {
                    ruleName = rule;
                }

                else {
                    ruleName = rule.name
                    settings = rule;
                    delete settings.name;
                }

                const handler = handlers[ruleName];
                if (typeof handler === 'function') {
                    try {
                        this.rules[ruleName] = new handler(this, settings);
                    }
                    catch (error) {
                        window.NRUM?.notifyError(error);
                        console.error(error);
                    }
                }
            }
        })
    }


    /**
     * @return {Element[]}
     */
    getElements() {
        return this.handler.getForm().elements;
    }

    getForm() {
        return this.handler.getForm();
    }

    getFormID() {
        return this.handler.getFormID();
    }

    /**
     * Return an array of rules. Must be overrided.
     * @return {Rules[]}
     */
    getRulesHandler() {
        return [
            // Rules
        ]
    }

    getMessage() {
        return `invalid`;
    }
}
